import { useContext } from 'react'

import { CalendarGridContext } from '../../CalendarGrid.context'

export function useCalendarGridContext() {
  return useContext(CalendarGridContext)
}
